import { render } from "./BigDataPage.vue?vue&type=template&id=03cb9988"
import script from "./BigDataPage.vue?vue&type=script&lang=js"
export * from "./BigDataPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__